import gql from 'graphql-tag';

export default gql`
mutation updateENCCPreferredModal($userId: String){
  updateENCCPreferredModal(userId: $userId) {
    customerActedOnENCCAsPreferredModal
  }
}
`;
